<template>
  <div class="side-bar">
    <el-menu
      :default-active="currentPage"
      :default-openeds="openNames"
      :router="true"
      class="el-menu-vertical-demo"
    >
      <template  v-for="menu in menuList">
        <el-submenu  v-if="menu.children && menu.children.length" :index="menu.name" :key="menu.name">
          <template slot="title" :route="{name: menu.name}">
            <i :class="menu.icon"></i>
            <span slot="title">{{ menu.title}}</span>
          </template>
          <el-menu-item style="padding-left:55px;" v-for="child in menu.children" :index="child.name" :key="child.name" :route="{name: child.name}">{{ child.title}}</el-menu-item>
        </el-submenu>
        <el-menu-item  v-else :index="menu.name" :key="menu.name" :route="{name: menu.name}"><i :class="menu.icon"></i>{{ menu.title}}</el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: 'SideMenu',
  props: {
    menuList: Array,
    openNames: {
      type: Array
    },
    currentPage: {
      type: String,
      default: ''
    }
  },
  watch: {
    currentPage (val) {
      console.log(val)
    }
  },
  data () {
    return {
    }
  }
}
</script>
<style lang="less">
.side-bar {
  &>.el-menu{
     &>.el-menu-item:first-child {
        border-bottom: 1px solid #979797;
        margin: 0 20px;
        padding:0 !important;
        height: 64px;
        &:hover {
          background-color: #354052;
        }
        &.is-active {
          background-color: #354052;
        }
      }
  }
  .el-menu {
    font-weight:400;
    border-right: 0;
    background-color: #354052;
    &.el-menu-vertical-demo{
      height: calc(100vh - 90px);
    }
    .el-submenu__title{
       font-size: 16px;
       color: #ffffff;
       &:hover{
         background-color: #5A75F6;
       }
       i:first-child{
        height: 18px;
        width: 18px;
        margin: 0 10px;
        color: #ffffff;
       }
    }
    .el-submenu{
      .el-menu-item{
        font-size: 14px;
        color: #dddddd;
      }
    }
  }
  .el-menu-item {
    font-size: 16px;
    color: #ffffff;
    &>i:first-child{
        height: 18px;
    }
    i {
      color: #fff;
    }
    .el-icon-agent-home{
      background:url('../../images/home/home.png') center center no-repeat;
    }
    &:hover{
      background-color: #5A75F6;
    }
    .menu-text {
      color: #FFFFFF;
      line-height: 60px;
   }
   &.is-active {
      background-color: #5A75F6;
      & .menu-text {
        color: #FFFFFF;
      }
    }
  }
  .el-menu--inline{
    .el-menu-item{
      padding-left: 65px !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/SideBar.vue